import RestApiClient from '../../api/RestApiClient';
import { IHeaderModuleSettings } from './types/IHeaderModuleSettings';

export default {
  getModulesSettings: async (): Promise<IHeaderModuleSettings> => {
    return await RestApiClient.get<IHeaderModuleSettings>(`modules/Header/getSettings`);
  },
};
